import isEmpty from 'lodash-es/isEmpty'
import { useRouter } from 'next/router'
import omitBy from 'lodash-es/omitBy'

import { TYPE_ORDER } from './filters.constants'
import { FilterOptionsQuestions } from './filters.types'

export const isEmptyQueryParams = <T>(query: T) =>
  isEmpty(removeEmptyFilterOptions(query))

export const removeEmptyFilterOptions = <T>(query: T) =>
  omitBy(query, isEmpty) as T

export const getFilterOptionsQuestions = <T extends FilterOptionsQuestions>(
  query: T
) => ({
  types: query?.types
})

export const useQueryParamsFilterQuestions = () => {
  const router = useRouter()
  const query = getFilterOptionsQuestions(
    router.query as FilterOptionsQuestions
  )
  const newQuery = removeEmptyFilterOptions(query)

  return {
    query: newQuery,
    state: {
      types:
        query?.types?.split(',').filter((item) => item !== '') ||
        TYPE_ORDER.map(([key, _]) => key)
    }
  }
}
